<template>
  <div class="front_wrap">
    <BreadCrumb crumb="内容统计"></BreadCrumb>
    <CountPannelTwo></CountPannelTwo>
    <CurveGraphTwo></CurveGraphTwo>
    <PieGraphTwo></PieGraphTwo>
    <PieGraphThree></PieGraphThree>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import CountPannelTwo from '@/components/widget/CountPannelTwo'
import CurveGraphTwo from '@/components/widget/CurveGraphTwo'
import PieGraphTwo from '@/components/widget/PieGraphTwo'
import PieGraphThree from '@/components/widget/PieGraphThree'
export default {
  name: 'ContentStatistics',
  data () {
    return {
    }
  },
  components:{
    BreadCrumb,
    CountPannelTwo,
    CurveGraphTwo,
    PieGraphTwo,
    PieGraphThree,
  },
  mounted(){

  },
  methods:{

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ContentStatistics.vue